const DAY = 24 * 60 * 60 * 1000;

/** Monday 00:00 of the week containing `d` (local time). */
export function startOfWeek(d: Date): Date {
  const r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const weekday = (r.getDay() + 6) % 7; // 0 = Monday
  r.setDate(r.getDate() - weekday);
  return r;
}

/** 0 = Monday … 6 = Sunday */
export function weekdayIndex(d: Date): number {
  return (d.getDay() + 6) % 7;
}

export function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseIsoDate(s: string): Date {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1);
}

/** Plan week (1-based) for `now`, counted in calendar weeks from the start date's week. */
export function planWeek(startDate: string, now: Date = new Date()): number {
  const start = startOfWeek(parseIsoDate(startDate)).getTime();
  const current = startOfWeek(now).getTime();
  return Math.max(1, Math.floor(Math.round((current - start) / DAY) / 7) + 1);
}

export function daysBetween(a: Date, b: Date): number {
  return Math.floor(Math.abs(b.getTime() - a.getTime()) / DAY);
}

/** Stable key like "2026-10-12" for the Monday of the week. */
export function weekKey(d: Date): string {
  return toIsoDate(startOfWeek(d));
}
